import {clearStorageForInactiveSessionWrapper} from './clear-inactive-session-storage';
import {checkSSOSessionWrapper} from './check-sso-session';
import { datadogRum } from '@datadog/browser-rum';
import type { AuthObject } from '@white-label-types/auth';
import type { Context } from '@white-label-types/global-context';

export const handleRedirectCallback = async (
  app: Context['app'],
  authInstance: AuthObject
  ) => {
  try {
    if (
      window.location.search.includes('code=') &&
      window.location.search.includes('state=')
    ) {
      await authInstance.auth0Client?.handleRedirectCallback();
      window.location.href = '/';
    }
  } catch (error) {
    const errorContext = {
      file: 'white-label-plugin > auth.ts > initAuth()',
      urlParamCode: window.location.search.includes('code='),
      urlParamState: window.location.search.includes('state='),
    };
    console.error(
      'Datadog error logged - error during initAuth',
      error,
      errorContext
    );
    datadogRum.addError(
      new Error('Error during initAuth:', { cause: error }),
      errorContext
    );
  } finally {
    await authInstance.refreshUser();

    clearStorageForInactiveSessionWrapper(app, authInstance);
    await checkSSOSessionWrapper(app, authInstance);
  }
};
